import React, {useState} from 'react';

import Input from '../../../ui/input';
import CountDown from '../../../ui/countDown';
import RepeatSms from './RepeatSms';
import RegWrapper from "../RegWrapper";
import {getLang} from "../../../../common";

const smsCheck = React.forwardRef((props, ref) => {

  const {
    brandName,
    lang,
    translationForReg,
    formData,
    verifyCode,
    onChangePhone,
    onRepeatSms,
    onInputVerifyCode,
    errorMessage
  } = props;

  const [timerCompleted, seTimerCompleted] = useState(false);

  const onClickRepeatSms = () => {
    onRepeatSms();
    seTimerCompleted(false);
  };

  return (
    <div className='VerifyNumber-Wrapper'>
      <div className='VerifyNumber-Title'>
        {getLang(translationForReg, brandName, lang, 'smsSentText')}
      </div>
      <div className='VerifyNumber-Phone'>
        {formData.phone}
      </div>
      <span className='VerifyNumber-changePhone link' onClick={onChangePhone}>
        {getLang(translationForReg, brandName, lang, 'specifyDifferentNumberText')}
      </span>
      <Input
        className='VerifyCode'
        label={getLang(translationForReg, brandName, lang, 'confirmationCodeTitle')}
        type='Text'
        value={verifyCode}
        onChange={onInputVerifyCode}
        error={errorMessage}
        ref={ref}
      />
      <div className='VerifyCode-Timer'>
        {!timerCompleted && <>
          <span>{getLang(translationForReg, brandName, lang, 'confirmCodeRepeatedRequest1')}</span>
          <CountDown
            time={300}
            active
            reverse
            onCompleted={() => seTimerCompleted(true)}
          />
          <span>{getLang(translationForReg, brandName, lang, 'confirmCodeRepeatedRequest2')}</span>
        </>}
        {timerCompleted ? <RepeatSms brandName={brandName} lang={lang} translationForReg={translationForReg} onClick={onClickRepeatSms} /> : null}
      </div>
    </div>
  );
});

export default smsCheck;
